import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Building2, HandHeart, ArrowRight, ShieldCheck } from 'lucide-react';

const R2S_NAVY = '#2A3B4A';
const R2S_ORANGE = '#C4703C';
const R2S_CREAM = '#F4F2EC';

export const RecoveryToServicePromoBanner = () => {
  const navigate = useNavigate();

  return (
    <section
      data-testid="r2s-homepage-promo-banner"
      style={{ padding: '5.5rem 0', background: R2S_NAVY, color: '#fff', position: 'relative', overflow: 'hidden' }}
      className="mobile-section-spacing"
    >
      <div style={{
        position: 'absolute', top: '-120px', right: '-120px', width: '340px', height: '340px',
        borderRadius: '50%', border: `1.5px solid ${R2S_ORANGE}55`, pointerEvents: 'none',
      }} />
      <div className="container mx-auto px-6" style={{ position: 'relative', zIndex: 1 }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1 }}
          style={{ textAlign: 'center', maxWidth: '760px', margin: '0 auto 3rem' }}
        >
          <p style={{
            color: R2S_ORANGE, letterSpacing: '0.14em', textTransform: 'uppercase', fontSize: '0.8rem',
            fontWeight: 700, marginBottom: '1rem', fontFamily: "'Manrope', sans-serif",
          }}>
            Recovery to Service
          </p>
          <h2 style={{
            fontFamily: 'var(--font-heading)', fontSize: 'clamp(2rem, 4vw, 2.75rem)', fontWeight: 700,
            marginBottom: '1.25rem', lineHeight: 1.25, color: '#fff',
          }}>
            Your recovery could be someone else's rescue.
          </h2>
          <p style={{ fontSize: '1.1rem', lineHeight: 1.7, color: 'rgba(255,255,255,0.85)' }}>
            A supervised, 36-week training that turns lived experience of addiction into safe, accountable peer
            support — free for every candidate, with a real certification and verification register behind it.
          </p>
        </motion.div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem', maxWidth: '900px', margin: '0 auto 3rem' }}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.9, delay: 0.05 }}
            style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: '10px', padding: '2rem' }}
          >
            <HandHeart size={30} color={R2S_ORANGE} style={{ marginBottom: '1rem' }} />
            <h3 style={{ fontFamily: 'var(--font-heading)', fontSize: '1.25rem', fontWeight: 700, marginBottom: '0.6rem', color: '#fff' }}>
              In recovery yourself?
            </h3>
            <p style={{ fontSize: '0.95rem', color: 'rgba(255,255,255,0.8)', lineHeight: 1.6, marginBottom: '1.25rem' }}>
              Train, get supervised, and become a certified peer supporter — walking others through what you've
              already survived. No course fees, ever.
            </p>
            <button
              data-testid="r2s-promo-individual-cta"
              onClick={() => navigate('/recovery-to-service')}
              style={{
                background: 'transparent', color: R2S_ORANGE, border: `1.5px solid ${R2S_ORANGE}`, borderRadius: '4px',
                padding: '0.7rem 1.4rem', fontWeight: 700, fontSize: '0.9rem', cursor: 'pointer',
                display: 'inline-flex', alignItems: 'center', gap: '0.5rem', fontFamily: "'Manrope', sans-serif",
              }}
            >
              Start Your Training <ArrowRight size={16} />
            </button>
            <div>
              <button
                data-testid="r2s-promo-individual-faq-link"
                onClick={() => navigate('/recovery-to-service/faq')}
                style={{ display: 'inline-block', marginTop: '0.9rem', background: 'none', border: 'none', color: 'rgba(255,255,255,0.65)', fontSize: '0.82rem', textDecoration: 'underline', cursor: 'pointer', fontFamily: "'Manrope', sans-serif" }}
              >
                Read the FAQ
              </button>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.9, delay: 0.15 }}
            style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: '10px', padding: '2rem' }}
          >
            <Building2 size={30} color={R2S_ORANGE} style={{ marginBottom: '1rem' }} />
            <h3 style={{ fontFamily: 'var(--font-heading)', fontSize: '1.25rem', fontWeight: 700, marginBottom: '0.6rem', color: '#fff' }}>
              Running a church or recovery org?
            </h3>
            <p style={{ fontSize: '0.95rem', color: 'rgba(255,255,255,0.8)', lineHeight: 1.6, marginBottom: '1.25rem' }}>
              Sponsor a cohort and build a supervised peer support bench you can trust — with safeguarding,
              accountability, and an official verification register.
            </p>
            <button
              data-testid="r2s-promo-org-cta"
              onClick={() => navigate('/recovery-to-service/register')}
              style={{
                background: R2S_ORANGE, color: '#fff', border: 'none', borderRadius: '4px',
                padding: '0.7rem 1.4rem', fontWeight: 700, fontSize: '0.9rem', cursor: 'pointer',
                display: 'inline-flex', alignItems: 'center', gap: '0.5rem', fontFamily: "'Manrope', sans-serif",
              }}
            >
              Register Your Organisation <ArrowRight size={16} />
            </button>
            <div>
              <button
                data-testid="r2s-promo-org-faq-link"
                onClick={() => navigate('/recovery-to-service/faq-for-organisations')}
                style={{ display: 'inline-block', marginTop: '0.9rem', background: 'none', border: 'none', color: 'rgba(255,255,255,0.65)', fontSize: '0.82rem', textDecoration: 'underline', cursor: 'pointer', fontFamily: "'Manrope', sans-serif" }}
              >
                Read the FAQ
              </button>
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, delay: 0.25 }}
          style={{ textAlign: 'center' }}
        >
          <button
            data-testid="r2s-promo-learn-more-btn"
            onClick={() => navigate('/recovery-to-service')}
            style={{
              background: R2S_CREAM, color: R2S_NAVY, border: 'none', borderRadius: '9999px',
              padding: '1rem 2.5rem', fontWeight: 700, fontSize: '1.05rem', cursor: 'pointer',
              display: 'inline-flex', alignItems: 'center', gap: '0.6rem', fontFamily: "'Manrope', sans-serif",
              boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
            }}
          >
            Explore Recovery to Service <ArrowRight size={18} />
          </button>
          <p style={{ marginTop: '1rem', fontSize: '0.82rem', color: 'rgba(255,255,255,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.4rem' }}>
            <ShieldCheck size={14} /> Supervised · Safeguarded · Verifiable
          </p>
        </motion.div>
      </div>
    </section>
  );
};
